import { ComplianceCaseTypeEnum } from "../graphql/supergraphEnums";
import { ComplianceCaseTypeEnum as ComplianceCaseType } from "../graphql/supergraphTypes";

export const completionText = (caseType: ComplianceCaseType) => {
  switch (caseType) {
    case ComplianceCaseTypeEnum.InvestorOnboarding:
    case ComplianceCaseTypeEnum.Remediation:
      return "Complete Identification";
    case ComplianceCaseTypeEnum.ProfileRefresh:
      return "Confirm information is accurate";
    default:
      return "Complete";
  }
};

export const completionTooltipText = (caseType: ComplianceCaseType) => {
  switch (caseType) {
    case ComplianceCaseTypeEnum.InvestorOnboarding:
    case ComplianceCaseTypeEnum.Remediation:
      return "All information must be complete before you can complete identification";
    case ComplianceCaseTypeEnum.ProfileRefresh:
      return "You must complete all sections that need review";
    case ComplianceCaseTypeEnum.DocumentRefresh:
      return "Information is required before you can complete this section.";
    default:
      return "Complete";
  }
};

export const isStandAloneCase = (caseType?: ComplianceCaseType | null): boolean => {
  return (
    caseType === ComplianceCaseTypeEnum.ProfileRefresh ||
    caseType === ComplianceCaseTypeEnum.DocumentRefresh
  );
};
